<template>
  <div class="change-shop-panel" :key="roleID">
    <button class="delete is-large is-pulled-right" @click="close" />
    <p class="subtitle" @click="changeShopSuperuser">
      Change Shop&nbsp;
      <i v-if="superuser" class="fa fa-mask has-text-info" />
    </p>

    <p>Active Shops</p>
    <div class="list">
      <p v-if="!activeShops.length" class="list-item has-text-danger">
        <i>No Active Shops</i>
      </p>
      <p
        v-for="s in activeShops"
        :key="s.id"
        class="list-item"
        @click="changeRole(s)"
      >
        {{ s.business.name }}
        <span class="is-pulled-right">
          <span v-if="isActiveRole(s)" class="tag is-success">
            <i class="fa fa-check" />
          </span>
          <span v-else class="tag is-dark">
            <i class="far fa-square" />
          </span>
        </span>
      </p>
    </div>

    <div v-if="hiddenShops.length">
      <p class="has-text-grey" style="margin-top: 16px">Hidden Shops</p>
      <div class="list">
        <p
          v-for="s in hiddenShops"
          :key="s.id"
          class="list-item has-text-grey"
          @click="changeRole(s)"
        >
          {{ s.business.name }}
          <span class="is-pulled-right">
            <span v-if="isActiveRole(s)" class="tag is-success">
              <i class="fa fa-check" />
            </span>
            <span v-else class="tag is-dark">
              <i class="far fa-square" />
            </span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangeShopPanel",
  props: {
    commerceAgentRoles: Array, // could include commerceManagerRoles
    currentRole: Object,
  },
  data() {
    return {};
  },
  computed: {
    superuser() {
      return this.$store.getters.isSuperUser;
    },
    roleID() {
      return this.currentRole.id;
    },
    activeShops() {
      return this.commerceAgentRoles.filter((r) => {
        if (r.business.data.hidden) return false;
        return true;
      });
    },
    hiddenShops() {
      return this.commerceAgentRoles.filter((r) => {
        if (r.business.data.hidden) return true;
        return false;
      });
    },
  },
  mounted() {
    console.log("commerceAgentRoles", this.commerceAgentRoles);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    changeShopSuperuser() {
      if (this.superuser) this.$emit("changeShopSuperuser");
    },
    isActiveRole(r) {
      return this.currentRole.id === r.id;
    },
    selectBusiness(businessID) {
      this.$store
        .dispatch("getAndSelectBusiness", businessID)
        .catch((err) => this.apiError(err));
      this.$store
        .dispatch("getWorkflows", businessID)
        .catch((err) => this.apiError(err));
    },
    changeRole(r) {
      this.$store.commit("clearCommerceAgentTransactions");
      this.$store.commit("activateCommerceAgentRoleByID", r.id);
      this.$store.commit("setActiveCommerceAgentRole", r.id);
      this.$nextTick(() => {
        this.z += 1;
        this.updateOrdersCommerceAgent(true);
        this.selectBusiness(r.business_id);
        var loader = this.loadingDots("blue");
        setTimeout(() => {
          console.log("commerceAgentRoles", this.commerceAgentRoles);
          loader.hide();
          var msg = "Changed to shop:<br>" + r.business.name;
          this.successToast(msg, "bottom");
          this.close();
        }, 2000);
      });
    },
  },
};
</script>

<style scoped>
.change-shop-panel {
  z-index: 3;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 10px;
  background-color: #1f1b24;
  color: white;
  padding-bottom: 20px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 0 4px 4px white;
}
.subtitle {
  margin-bottom: 16px;
  color: #ccc;
}
.list {
  background-color: black;
  margin-top: 6px;
}
.list-item {
  color: white;
  border-bottom: 1px solid #333;
  padding: 10px 12px;
}
</style>